import { createAction, props } from '@ngrx/store';
import { Steps, Workflows } from './workflows.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records workflows'
);

export const fetchRecordsSuccess = createAction(
    '[Data] fetch records workflows success', 
    props<{ listData: Workflows[], total: number }>()
);

export const fetchRecordsFail = createAction(
    '[Data] fetch records workflows failure', 
    props<{ error: string }>()
);


// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record workflows',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record workflows success', 
    props<{ singleData: Workflows, steps: Steps[] }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record workflows failure', 
    props<{ error: string }>()
);

//Update Member Email
export const updateMemberEmail = createAction(
  '[Workflow Failed Email] Update Member Email',
  props<{ memberId: string; email: string }>()
);

export const updateMemberEmailSuccess = createAction(
  '[Workflow Failed Email] Update Member Email Success',
  props<{ memberId: string; email: string; message?: string }>()
);

export const updateMemberEmailFail = createAction(
  '[Workflow Failed Email] Update Member Email Fail',
  props<{ memberId: string; error: any }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state workflows',
);